var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.088 2.781A6.13 6.13 0 0 0 13 8.65 6.134 6.134 0 0 1 1 6.869 6.13 6.13 0 0 1 5.35 1a6.1 6.1 0 0 0-.262 1.781"
  })));
};
export { SvgMoon as ReactComponent };
export default __webpack_public_path__ + "517be9614ebac076a36d3213c8d10870.svg";